'use strict';
var util = require('../util');

module.exports = {
  appVersion: '8.1.2',

  share: function(opts) {
    
    opts.feed = this._parseFeed(opts.feed);
    opts.url = this._tidyUrlParams(opts.url);
    
    this._send('share', opts);
  },
  setBarrageEnabled: function(opts) {
    this._send('setBarrageEnabled',opts);
  }

};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/patch/patch-8.1.2.js
// module id = 559
// module chunks = 0